import React, { Component,useRef } from 'react'

export class LeranReactrefCompoent extends Component {
    constructor(props) {
        super(props)    
        this.countref=React.createRef()
    }
    incrementCounter=()=>{
        this.countref.current.value++;
    }
    render(){
        alert('Text Message');
        return (            
            <div>  
                <p>
                <label>Enter Quantity:<input ref={this.countref} tyep="text"></input>
                <button onClick={this.incrementCounter}>Increment</button>
                </label>
                </p>
            </div>
        );
    }
}

export default LeranReactrefCompoent
